import { pesos } from '../constants/constants';

export const calcularPeso = (est) => {
  const pesoFormato = Number(pesos.formato[est.formato]) || 1;
  const pesoSteps = Number(pesos.steps[est.steps]) || 1;
  const pesoItens = Number(pesos.possuiItensDinamicos[est.possuiItensDinamicos]) || 1;
  const tipoArray = Array.isArray(est.tipoDCO) ? est.tipoDCO : (est.tipoDCO ? [est.tipoDCO] : []);
  const pesoTipoDCO = tipoArray.length
    ? Math.max(...tipoArray.map(t => Number(pesos.tipoDCO?.[t]) || 1))
    : 1;

  const pesoVersoes = 0;
  const pesoMockup = Number(pesos.mockup[est.mockup]) || 1;
  const pesoAlimentacao = Number(pesos.alimentacao[est.alimentacao]) || 1;
  const pesoUrgencia = Number(pesos.urgencia[est.urgencia]) || 1;
  const pesoCarrossel = est.formato === 'shoppable' && est.carrossel ? pesos.carrossel : 0;

  return (
    pesoFormato +
    pesoSteps +
    pesoItens +
    pesoVersoes +
    pesoMockup +
    pesoAlimentacao +
    pesoUrgencia +
    pesoCarrossel +
    pesoTipoDCO
  );
};

export const validarEstimativa = (est) => {
  const errs = {};
  const obrig = (v) => v !== undefined && v !== null && String(v).trim() !== '';

  if (!obrig(est.formato)) errs.formato = 'Select the creative format.';
  if (!obrig(est.steps)) errs.steps = 'Inform the interaction levels.';
  if (!obrig(est.mockup)) errs.mockup = 'Inform the material available.';
  if (!obrig(est.alimentacao)) errs.alimentacao = 'Select the feed integration method.';
  if (!obrig(est.volumetria)) errs.volumetria = 'Inform the volumetric output.';


  const precisaAdaptacao = ['desdobrar', 'criar', 'clienteFornece'].includes(est.mockup);
  if (precisaAdaptacao && (!Number.isFinite(est.desdobramentos) || est.desdobramentos < 1)) {
    errs.desdobramentos = 'Enter a quantity >= 1.';
  }

  if (est.alimentacao === 'powerfeed' && (!Number.isFinite(est.versoes) || est.versoes < 1)) {
    errs.versoes = 'Powerfeed requires versions >= 1.';
  }

  return errs;
};

export const validateForm = (estimativas, dadosComerciais, setErrosComerciais, setErrors, setAlert) => {
  const errosPorIndex = {};
  estimativas.forEach((est, i) => {
    const e = validarEstimativa(est);
    if (Object.keys(e).length) errosPorIndex[i] = e;
  });

  const camposComerciais = {};
  if (!dadosComerciais.nomeProjeto?.trim()) camposComerciais.nomeProjeto = true;
  if (!dadosComerciais.nomeCliente?.trim()) camposComerciais.nomeCliente = true;
  if (!dadosComerciais.urgencia?.trim()) camposComerciais.urgencia = true;

  setErrosComerciais(camposComerciais);
  setErrors(errosPorIndex);

  if (Object.keys(camposComerciais).length) {
    setAlert({ type: 'erro', message: 'Please fill: Project name, Client name, Owner and Priority.' });
    return false;
  }
  if (Object.keys(errosPorIndex).length) {
    const primeiroIdx = Number(Object.keys(errosPorIndex)[0]);
    document.querySelector(`[data-accordion-index="${primeiroIdx}"]`)?.scrollIntoView({ behavior: 'smooth' });
    return false;
  }
  return true;
};
